module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Dittingen-a5a66c07709985280cd77d23f4c4e077.png";